// extracted by mini-css-extract-plugin
export default {"cls1":"jchnylE_23_6UXe1oPox","cls2":"ifZKdVKBx1sqCMxlhcrX jchnylE_23_6UXe1oPox"};